export default class Ownership {
    id: number;
    decimalInterest: number;
    ownershipType: string;
    isCommunityProperty?: boolean;
    vestingDeedReference?: string;
    vestingDeedDate?: Date;
    vestingDeedInstrumentType?: string;
    vestingDeedInstrumentSource?: string;
    vestingDeedInstrumentId?: number;
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/Ownership.ts